import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import WhatsAppFloat from "@/components/landing/WhatsAppFloat";

/**
 * Shared chrome for every SEO content page — keeps Navbar/Footer/WhatsAppFloat consistent.
 * Children render between header and footer.
 */
export default function SeoPageLayout({ children, schemas = [] }) {
  return (
    <div
      className="min-h-screen overflow-x-hidden"
      style={{ background: "var(--iw-bg)" }}
    >
      {/* JSON-LD schemas */}
      {schemas.map((s, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(s) }}
        />
      ))}

      <Navbar />
      <main className="pt-24 md:pt-28">{children}</main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
